/* Supertee site script: shared helpers plus the market logic for the home page */
(function(){
  // YouTube: load the player only when someone presses play
  Array.prototype.forEach.call(document.querySelectorAll('[data-yt]'), function(b){
    b.addEventListener('click', function(){
      var id = b.getAttribute('data-yt');
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
      f.title = b.getAttribute('aria-label') || 'Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      b.innerHTML = ''; b.appendChild(f); b.removeAttribute('aria-label'); b.style.cursor = 'default';
    }, { once: true });
  });
  // Mobile menu: close after choosing a link or tapping outside
  Array.prototype.forEach.call(document.querySelectorAll('.stw-menu'), function(d){
    d.addEventListener('click', function(e){ if (e.target.closest('a')) d.removeAttribute('open'); });
    document.addEventListener('click', function(e){ if (d.hasAttribute('open') && !d.contains(e.target)) d.removeAttribute('open'); });
  });
  // Smooth in-page links outside the home page logic
  if (!document.querySelector('[data-stw-home]')) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-scroll]'), function(a){ a.addEventListener('click', function(e){
      var t = document.querySelector(a.getAttribute('href')); if (!t) return;
      e.preventDefault(); t.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }); });
  }
})();

(function(){
  var root = document.querySelector('[data-stw-home]');
  if (!root) return;
  var markets = [];
  try { markets = JSON.parse(root.querySelector('[data-markets]').textContent) || []; } catch(e) {}
  markets = markets.filter(function(m){ return m.code && m.url; });
  if (!markets.length) return;

  var KEY = 'st_market';
  var ALIASES = { sa:'za', gb:'uk', aus:'au' };
  var TZ = [['Pacific/Auckland','nz'],['Pacific/Chatham','nz'],['Australia/','au'],['Europe/London','uk'],['Europe/Belfast','uk'],['Africa/Johannesburg','za']];
  var LANG = { NZ:'nz', AU:'au', GB:'uk', ZA:'za' };
  var current = null, filter = 'all';

  function each(sel, fn){ Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }
  function byCode(c){ c = (c||'').toLowerCase().trim(); c = ALIASES[c] || c; for (var i=0;i<markets.length;i++){ if (markets[i].code === c) return markets[i]; } return null; }
  function store(get, val){ try { if (get) return localStorage.getItem(KEY); localStorage.setItem(KEY, val); } catch(e) { return null; } }
  function the(country){ return /^(united|netherlands|philippines)/i.test(country) ? 'the ' + country : country; }
  function track(evt, data){
    try { window.dataLayer = window.dataLayer || []; data.event = evt; window.dataLayer.push(data); } catch(e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(evt, data); } catch(e) {}
  }
  function detect(){
    try { var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      for (var i=0;i<TZ.length;i++){ if (tz.indexOf(TZ[i][0]) === 0 && byCode(TZ[i][1])) return byCode(TZ[i][1]); } } catch(e) {}
    var langs = navigator.languages || [navigator.language || ''];
    for (var j=0;j<langs.length;j++){ var r = (langs[j].split('-')[1]||'').toUpperCase(); if (LANG[r] && byCode(LANG[r])) return byCode(LANG[r]); }
    return markets[0];
  }
  function withUtm(url, content){
    if (!url || url.indexOf('utm_') !== -1) return url;
    var hash = '', i = url.indexOf('#'); if (i !== -1) { hash = url.slice(i); url = url.slice(0, i); }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'utm_source=supertee&utm_medium=referral&utm_campaign=where_to_buy&utm_content=' + encodeURIComponent(content) + hash;
  }

  function applyFilter(){
    each('[data-tee]', function(c){ c.classList.toggle('is-filtered', filter !== 'all' && c.getAttribute('data-group') !== filter); });
    each('[data-filter]', function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-filter') === filter ? 'true' : 'false'); });
  }

  function linkFor(el, m, kind){ return el.getAttribute('data-' + kind + '-' + m.code) || ''; }
  function setBuy(ui, link, pink, m, name){
    var buy = ui.querySelector('[data-buy]'), pinkA = ui.querySelector('[data-pink]'), na = ui.querySelector('[data-na]');
    if (link) {
      buy.href = withUtm(link, buy.getAttribute('data-product') + '_' + m.code);
      buy.setAttribute('aria-label', 'Buy the ' + name + ' at ' + m.retailer + ' (opens in a new tab)');
      buy.hidden = false; na.hidden = true;
    } else { buy.hidden = true; na.hidden = false; }
    if (pink && link) { pinkA.href = withUtm(pink, pinkA.getAttribute('data-product') + '_' + m.code); pinkA.hidden = false; } else { pinkA.hidden = true; }
  }

  // Featured product
  var feat = root.querySelector('[data-feat]');
  function updateFeat(){
    if (!feat || !current) return;
    var r = feat.querySelector('input[type="radio"]:checked') || feat.querySelector('input[type="radio"]');
    if (!r) return;
    r.checked = true;
    var opt = r.closest('[data-opt]'), h = opt.getAttribute('data-opt'), name = opt.getAttribute('data-name');
    each('[data-opt]', function(o){ o.classList.toggle('is-sel', o === opt); });
    each('[data-gal]', function(g){ g.hidden = g.getAttribute('data-gal') !== h; });
    feat.querySelector('.stw-feat__best [data-best]').textContent = opt.getAttribute('data-bestfor') || '';
    feat.querySelector('[data-height-name]').textContent = name;
    var ui = feat.querySelector('[data-feat-buy]');
    ui.querySelector('[data-buy]').setAttribute('data-product', h);
    ui.querySelector('[data-pink]').setAttribute('data-product', h + '-pink');
    setBuy(ui, linkFor(opt, current, 'link'), linkFor(opt, current, 'pink'), current, name);
  }
  if (feat) {
    each('[data-opt] input', function(r){ r.addEventListener('change', updateFeat); });
    each('[data-gal]', function(g){
      var imgs = g.querySelectorAll('.stw-gal__main img'), thumbs = g.querySelectorAll('[data-thumb]');
      Array.prototype.forEach.call(thumbs, function(b){
        b.addEventListener('click', function(){
          var i = +b.getAttribute('data-thumb');
          Array.prototype.forEach.call(imgs, function(im, j){ im.classList.toggle('is-on', j === i); });
          Array.prototype.forEach.call(thumbs, function(t){ t.setAttribute('aria-pressed', t === b ? 'true' : 'false'); });
        });
      });
    });
  }

  function render(m){
    current = m;
    root.setAttribute('data-market', m.code);
    each('[data-country-name]', function(el){ el.textContent = m.country; });
    each('[data-country-the]', function(el){ el.textContent = the(m.country); });
    each('[data-country-short]', function(el){ el.textContent = m.short || m.code.toUpperCase(); });
    each('[data-retailer]', function(el){ el.textContent = m.retailer; });
    each('[data-range]', function(a){ a.href = withUtm(m.url, 'range_' + m.code); });
    var note = root.querySelector('[data-note]');
    if (note) { if (m.note) { note.textContent = ' ' + m.note; note.hidden = false; } else { note.hidden = true; } }
    var total = 0, stocked = 0;
    each('[data-tee]', function(el){
      var link = linkFor(el, m, 'link');
      el.classList.toggle('is-out', !link);
      setBuy(el, link, linkFor(el, m, 'pink'), m, ((el.querySelector('h3') || {}).textContent || '').trim());
      total++; if (link) stocked++;
    });
    each('[data-rail]', function(li){
      var card = root.querySelector('[data-tee="' + li.getAttribute('data-rail') + '"]');
      li.hidden = !!(card && card.classList.contains('is-out'));
    });
    var firstIn = null, sel = null;
    each('[data-opt]', function(o){
      var ok = !!linkFor(o, m, 'link');
      o.classList.toggle('is-out', !ok);
      o.querySelector('[data-opt-na]').hidden = ok;
      if (ok && !firstIn) firstIn = o;
      if (o.querySelector('input').checked) sel = o;
    });
    if (sel && sel.classList.contains('is-out') && firstIn) firstIn.querySelector('input').checked = true;
    updateFeat();
    var count = root.querySelector('[data-count]');
    if (count) count.textContent = stocked + ' of ' + total + ' tees available in ' + the(m.country) + '.';
  }

  function choose(m, method){
    render(m); store(false, m.code);
    track('st_market_select', { st_market: m.code, st_country: m.country, st_method: method });
  }

  // Filters
  each('[data-filter]', function(b){ b.addEventListener('click', function(){ filter = b.getAttribute('data-filter'); applyFilter(); }); });
  var instock = root.querySelector('[data-instock]');
  if (instock) {
    if (root.getAttribute('data-unstocked') === 'hide') { instock.checked = true; }
    instock.addEventListener('change', function(){ root.classList.toggle('is-instock', instock.checked); });
    root.classList.toggle('is-instock', instock.checked);
  }

  // Country dialog
  var gate = root.querySelector('[data-gate]'), list = root.querySelector('[data-gate-list]'), lastFocus = null;
  function openGate(){
    var suggested = current || detect();
    list.innerHTML = '';
    var ordered = markets.slice().sort(function(a,b){ return a === suggested ? -1 : b === suggested ? 1 : 0; });
    ordered.forEach(function(m){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'stw-gate__opt';
      var txt = document.createElement('span');
      var name = document.createElement('b'); name.textContent = m.country;
      var sub = document.createElement('small'); sub.textContent = 'Sold by ' + m.retailer;
      txt.appendChild(name); txt.appendChild(sub); b.appendChild(txt);
      if (m === suggested) { var em = document.createElement('em'); em.textContent = current ? 'Selected' : 'Suggested'; b.appendChild(em); }
      b.addEventListener('click', function(){ choose(m, 'gate'); closeGate(); });
      list.appendChild(b);
    });
    lastFocus = document.activeElement;
    gate.hidden = false; document.body.classList.add('stw-locked');
    var first = list.querySelector('button'); if (first) first.focus();
  }
  function closeGate(){
    if (!current) render(detect());
    gate.hidden = true; document.body.classList.remove('stw-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  each('[data-open-gate]', function(b){ b.addEventListener('click', openGate); });
  root.querySelector('[data-gate-close]').addEventListener('click', closeGate);
  gate.addEventListener('click', function(e){ if (e.target === gate) closeGate(); });
  document.addEventListener('keydown', function(e){
    if (gate.hidden) return;
    if (e.key === 'Escape') closeGate();
    if (e.key === 'Tab') {
      var f = gate.querySelectorAll('button,a'); if (!f.length) return;
      var a = f[0], z = f[f.length-1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });

  // In-page links
  each('[data-scroll]', function(a){ a.addEventListener('click', function(e){
    var t = document.querySelector(a.getAttribute('href')); if (!t) return;
    if (a.hasAttribute('data-rail-link') && filter !== 'all') { filter = 'all'; applyFilter(); }
    e.preventDefault(); t.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }); });

  // Retailer clicks
  root.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('[data-buy],[data-pink],[data-range]');
    if (!a || !current) return;
    var product = a.getAttribute('data-product') || 'range';
    var placement = a.closest('[data-feat-buy]') ? 'elite_feature' : (a.closest('[data-tee]') ? 'range_grid' : 'footer');
    track('st_retailer_click', { st_market: current.code, st_country: current.country, st_retailer: current.retailer, st_product: product, st_placement: placement, st_link_url: a.href });
    try { if (window.fbq) window.fbq('trackCustom', 'RetailerClick', { market: current.code, retailer: current.retailer, product: product, placement: placement }); } catch(err) {}
  });

  // Theme editor
  document.addEventListener('shopify:block:select', function(e){
    for (var i=0;i<markets.length;i++){ if (markets[i].id === (e.detail && e.detail.blockId)) { render(markets[i]); gate.hidden = true; } }
  });

  // Start: ?market= (ads) > saved choice > dialog
  var params = new URLSearchParams(window.location.search);
  var fromUrl = byCode(params.get('market') || params.get('country'));
  var saved = byCode(store(true));
  applyFilter();
  if (fromUrl) { choose(fromUrl, 'url'); }
  else if (saved) { render(saved); }
  else if (window.Shopify && Shopify.designMode) { render(detect()); }
  else { render(detect()); current = null; openGate(); }
})();
